module.exports = __webpack_public_path__ + "imgs/worldclass_big.bf86d7ed.webp";